"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useClickOutside = void 0;
var react_1 = require("react");
var useClickOutside = function (action, ref) {
    var handleClickOutside = (0, react_1.useCallback)(function (e) {
        var _a;
        if (ref && ref.current) {
            if (!((_a = ref === null || ref === void 0 ? void 0 : ref.current) === null || _a === void 0 ? void 0 : _a.contains(e.target))) {
                action();
            }
        }
    }, [action, ref]);
    (0, react_1.useEffect)(function () {
        document.addEventListener('mousedown', handleClickOutside);
        return function () { return document.removeEventListener('mousedown', handleClickOutside); };
    }, [handleClickOutside]);
};
exports.useClickOutside = useClickOutside;
